function showVideo(videoId, title, body) {
  $("#modalVideoYouTube")
    .find(".modal-title")
    .text(title);
  $("#modalVideoYouTube")
    .find(".modal-description")
    .text(body);
  $("#modalVideoYouTube")
    .find("iframe")
    .attr(
      "src",
      "https://www.youtube-nocookie.com/embed/" +
        videoId +
        "?rel=0&amp;showinfo=0"
    );
  $("#modalVideoYouTube").modal("show");
}
(function() {
  $("#modalVideoYouTube").on("hide.bs.modal", function(event) {
    $("#modalVideoYouTube")
      .find("iframe")
      .attr("src", "");
  });
})(jQuery);
